const calculateCpc = (data) => {
	const cpcCount = data.filter(({ cpc }) => cpc > 0).length;
	const cpc = (data.reduce((acc, cur) => acc + cur.cpc, 0) / cpcCount || 0).toFixed(2);

	return cpc;
};

export default calculateCpc;
